import styled, { css, keyframes } from 'styled-components';
import { Row, Col } from '@pickit/pickit-grid-system';

const shine = keyframes`
  0% {background-position: 100%}
  100% {background-position: -140%}
`;

const backgrounGradient = css`
  background-image: linear-gradient(90deg, #ddd 8%, #f5f5f5 18%, #ddd 33%);
  background-size: 200% 100%;
  animation: ${shine} 1s infinite linear;
`;

export const SkeletonItem = styled.div<{
  rounded?: boolean;
  width?: string;
  height?: string;
}>`
  position: relative;
  height: ${({ height }) => height || '100%'};
  ${({ height }) =>
    height &&
    css`
      min-height: ${height};
    `}

  width: ${({ width }) => width || '100%'};
  border-radius: ${({ rounded }) => (rounded ? '50%' : '10px')};
  ${backgrounGradient}
`;

export const SkeletonRow = styled(Row)<{ height: string; marginBottom?: number; align?: string }>`
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}
  margin-bottom: ${({ marginBottom }) => marginBottom}px !important;
  ${({ align }) =>
    align &&
    css`
      justify-content: ${align};
    `}
`;

export const SkeletonCol = styled(Col)<{ gap: number; align?: string }>`
  display: flex;
  flex-direction: column;

  ${({ align }) =>
    align &&
    css`
      align-items: ${align};
    `}

  ${({ gap }) =>
    gap &&
    css`
      gap: ${gap}px;
    `}
`;
